
import Experience from './Experience/Experience.js'

// Canvas
const canvas = document.querySelector('canvas.webgl')


function isMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
}
if (!isMobile()) {
    const experience = new Experience(canvas)
} else {
    document.querySelector('body').innerHTML = 'VA VOIR CA SUR ORDI'
}
